import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ModalContext } from '../../../contexts';
// import styles from './styles.scoped.css';

export default function Modal({
  children = null,
  className = '',
  lastUpdate = 0,
  onClose = () => {},
  open = false,
}) {
  const { content, setContent } = useContext(ModalContext);

  useEffect(() => {
    if (open) setContent(<Content children={children} className={className} />);
    else setContent(null);
  }, [open, lastUpdate]);

  const [modalContent, setModalContent] = useState(content);

  useEffect(() => {
    if (modalContent && !content) {
      onClose();
      setModalContent(content);
    } else if (!modalContent && content) {
      setModalContent(content);
    }
  });

  return null;
}

Modal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  lastUpdate: PropTypes.number,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

// Provide defaultProps to satisfy tests calling Modal.defaultProps.onClose()
Modal.defaultProps = {
  children: null,
  className: '',
  lastUpdate: 0,
  onClose: () => {},
  open: false,
};

export function Content({ className, children }) {
  const customClass = ['root', className].filter(Boolean).join(' ');
  return <section className={customClass}>{children}</section>;
}

Content.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
